import dayjs from 'dayjs';
import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { TwoLineCell } from '../../components/QueueCells';

interface SignedUpRowLike extends MRT_RowData {
  signupAt?: string;
}

// 8px wider than the prototype's 76, so the label and sort arrow aren't clipped.
const SIGNED_UP_SIZE = 84;

/** The sign-up date over the time of day (`9:07am`). Inquiry's date column. */
export function signedUpColumn<Row extends SignedUpRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'signedUp',
    header: 'Signed up',
    size: SIGNED_UP_SIZE,
    accessorFn: (row) => row?.signupAt ?? '',
    sortingFn: 'datetime',
    Cell: ({ row }) => {
      const signupAt = row.original?.signupAt;
      return signupAt ? (
        <TwoLineCell primary={dayjs(signupAt).format('MMM D')} secondary={dayjs(signupAt).format('h:mma')} />
      ) : (
        <TwoLineCell primary="—" />
      );
    },
  };
}
